module.exports = __webpack_public_path__ + "img/parking-spots.6afe41e2.svg";